{
  "import_layer": {
    "title": "Eine Ebene importieren",
    "confirm": "Ebenen importieren"
  },
  "data_fields": {
    "title": "Attribute",
    "add": "Attribut hinzufügen",
    "project_data_fields": "Vordefiniertes Attribut",
    "custom_data_field": "Benutzerdefiniertes Attribut",
    "type": "Typ",
    "name": "Name des Attributs",
    "list_name": "Name der Liste",
    "list_items": "Artikel auflisten",
    "list_item": "Artikel auflisten",
    "types": {
      "Text": "Text",
      "List": "Liste",
      "Number": "Nummer",
      "Date": "Datum",
      "Tickbox": "Kästchen ankreuzen",
      "Time": "Zeit",
      "TimeRange": "Zeitbereich",
      "Image": "Bild",
      "Hyperlink": "Hyperlink",
      "RepeatedTimeRanges": "Datums- und Zeitbereiche"
    },
    "data_driven_formula": {
      "title": "Neue Formel erstellen",
      "label": "Ermitteln Sie {{ styleProperty }} durch",
      "addListItem": "Listeneintrag hinzufügen",
      "searchListItem": "Suchen Sie nach einem Listeneintrag"
    }
  },
  "saved_map_view": {
    "default_label": "Machen Sie dies zur Standardansicht des Plans.",
    "default_description": "Dadurch wird das Vorschaubild des Plans definiert und diese Ansicht wird für alle Benutzer geladen, wenn sie den Plan öffnen.",
    "form_header": "Benennen Sie diese gespeicherte Ansicht",
    "name_label": "Name der gespeicherten Ansicht",
    "create_saved_view": "Eine gespeicherte Ansicht erstellen",
    "create_new_saved_view": "Erstellen Sie eine neue gespeicherte Ansicht",
    "edit_saved_view": "Bearbeiten Sie die gespeicherte Ansicht",
    "move_map_around": "Verschieben Sie den Plan, bis Sie mit der neuen Ansicht zufrieden sind.",
    "save_view_when_ready": "Wenn Sie fertig sind, tippen Sie auf „Änderungen speichern“, um die Ansicht zu speichern.",
    "map_default": "Standardplan"
  },
  "create_map": {
    "create_map": "Plan erstellen",
    "create_a_map": "Erstellen Sie einen Plan",
    "modal_label": "Name des Plans",
    "create_a_new_map": "Einen neuen Plan erstellen"
  },
  "buttons": {
    "new_layer": "Neue Ebene",
    "import_layer": "Ebene importieren",
    "site_map": "Seitenverzeichnis",
    "background": "Hintergrund",
    "create_layer": "Ebene erstellen",
    "cancel": "Stornieren",
    "share_table": "Tabelle teilen",
    "download_table": "Tabelle herunterladen",
    "toggle_sidebar": "Seitenleiste umschalten",
    "columns_displayed": "angezeigte Spalten",
    "closePopup": "Popup schließen",
    "openBasemapSelector": "Öffnen Sie den Grundkarten-Selektor",
    "removeSiteMap": "Sitemap aus der Ansicht entfernen"
  },
  "labels": {
    "object": "Objekt",
    "object_id": "Objekt-ID",
    "object_name": "Name des Objekts",
    "layer": "Ebene",
    "zone": "Zone",
    "zones": "Zonen",
    "client_group": "Kundengruppe"
  },
  "nav": {
    "layers": "Schichten",
    "data_table": "Datentabelle",
    "sitemap": "Seitenverzeichnis",
    "background": "Hintergrund",
    "basemap": "Grundkarte",
    "background_maps": "Karten im Hintergrund",
    "selectSitemap": "Wählen Sie Sitemap",
    "selectLevel": "Stufe wählen",
    "search": "Suchen"
  },
  "popup": {
    "view_by_layer": "Nach Ebene anzeigen",
    "view_by_data_field": "Nach Datenfeld anzeigen",
    "view_by_object": "Nach Objekt anzeigen",
    "sitemapsAvailableAtThisLocation": "Sitemaps sind an diesem Standort verfügbar",
    "closeSitemapSelector": "Schließen Sie den Sitemap-Selektor",
    "sitemapLevels": "Ebenen der Sitemap",
    "closeLevelSelector": "Level-Selektor schließen",
    "saved_map_views": "Gespeicherte Ansichten"
  },
  "add_layer": {
    "create_a_new_layer": "Erstellen Sie eine neue Ebene",
    "new_layer": "Neue Ebene",
    "name_of_layer": "Name der Ebene",
    "layer_style": "Ebenenstil",
    "layer_style_desc": "Wählen Sie einen Zeichnungstyp oder eine Stilvorlage",
    "drawing_type": "Zeichnungstyp",
    "area": "Bereich",
    "lines": "Linien",
    "points": "Punkte",
    "text_labels": "Textbeschriftungen",
    "templates": "Vorlagen",
    "shape_and_colour": "Form und Farbe",
    "line_colour": "Farbe der Linie",
    "fill_opacity": "Deckkraft der Füllung",
    "preview": "Vorschau",
    "width": "Breite",
    "offset": "Offset",
    "zones": "Zonen",
    "list_of_options": "Liste der Optionen",
    "layer_design": "Layer-Design",
    "layer_templates": "Ebenen-Vorlagen",
    "view_all_templates": "Alle Ebenenvorlagen anzeigen",
    "scratch": "Eine Ebene von Grund auf neu erstellen",
    "save_layer": "Ebene speichern",
    "type_of_layer": "Art der Ebene",
    "styles": "Stile",
    "save_style": "Stil speichern",
    "more": "Mehr",
    "Line": "Linie",
    "Icon": "Symbol",
    "Point": "Punkt",
    "Area": "Gebiet",
    "layer_being_created": "Ebene wird erstellt..."
  },
  "measurements": {
    "unit_of_measurement": "Maßeinheit",
    "imperial": "Imperial",
    "metric": "Metrisch"
  },
  "sidebar": {
    "node_name": "Der Name muss mindestens 2 Zeichen lang sein"
  },
  "import_layers_tooltip": {
    "Layer": "Die Ebene ist in diesem Plan bereits vorhanden"
  },
  "search": {
    "search_map": "Suchen",
    "locations": "Standorte",
    "objects": "Objekte",
    "search_description": "Suche nach Standort, gespeicherter Ansicht, Objekt",
    "saved_map_view": "Gespeicherte Ansichten",
    "no_results": "Keine Ergebnisse stimmten mit Ihrer Anfrage überein",
    "sitemaps": "Sitemaps"
  }
}